<div class="panel-header">
	<div class="column title">
		<h2>Gemiddelde aanwezigheid per schooldag</h2>
		<div class="subtitle">Schooljaar {{ schooljaar() }}</div>
	</div>
	<div class="column" data-princexml-ignore data-html2canvas-ignore>
		<app-icon name="info" color="primary-1" hoverColor="primary-2" size="small" [appTooltip]="perSchooldagInfo"></app-icon>
	</div>
	<ng-template #perSchooldagInfo>
		<div class="tooltip">
			<h4>Gemiddelde aanwezigheid per schooldag</h4>
			<p>Toont de gemiddelde aanwezigheid van de geselecteerde leerlingen per schooldag in een maand binnen het gekozen schooljaar.</p>
			<ol>
				<li>Goede aanwezigheid (groen): ≥ 95% aanwezig</li>
				<li>Beginnend verzuim (geel): &gt; 90% - &lt; 95% aanwezig</li>
				<li>Aanhoudend verzuim (rood): ≤ 90% aanwezig</li>
			</ol>
		</div>
	</ng-template>
</div>
<div class="panel-content">
	<app-aanwezigheid-matrix [data]="perSchooldagData()" [loading]="loading()" class="high-cells"></app-aanwezigheid-matrix>
</div>
